<div *ngIf="notes.length" layout="column" class="notes-container">
  <div layout="column"
       *ngFor="let note of notes;let first = first"
       [ngClass]="{'margin-top-5': !first}">
    <span class="br-body-2 desc-txt">{{note}}</span>
  </div>
</div>
